<template>
  <div :class="['container', { 'container-dark': theme_dark }]">
    <div class="nav-top">
      <div class="nav-left" @click="back()">
        <img src="../../assets/img/返回箭头.png" class="nav-img" />
        <span class="nav-lable"></span>
      </div>
      <div class="nav-middle">常见问题</div>
      <div class="nav-right">
        <span class="nav-lable"></span>
        <img src="../../assets/img/更换.png" class="nav-img none" />
      </div>
    </div>

    <ul class="content">
      <li class="item">
        <div class="question ub ub-pc"><div class="tag"></div><span>金币是什么？</span></div>
        <div class="answer"><span>金币是平台的通用货币，可以用来消费，购买相关服务，比如：购买礼物，加好友等。</span> </div>
      </li>

      <li class="item">
        <div class="question ub ub-pc"><div class="tag"></div><span>积分是什么？</span></div>
        <div class="answer"><span>积分是小火柴平台内用户收益的计算标准。积分可以直接提现，积分越高收益越高。</span></div>
      </li>

      <li class="item">
        <div class="question ub ub-pc"><div class="tag"></div><span>魅力值是什么？</span> </div>
        <div class="answer"><span>魅力值 = 总积分，魅力值是累加的，每获得一次积分，魅力值就相应的增加。</span></div>
      </li>

      <li class="item">
        <div class="question ub ub-pc"><div class="tag"></div><span>豪气值是什么？</span></div>
        <div class="answer"><span>豪气值 = 总金币，豪气值是累加的，每获得一次金币，豪气值就相应的增加。</span></div>
      </li>

      <li class="item">
        <div class="question ub ub-pc"><div class="tag"></div><span>系统里边有机器人吗？</span></div>
        <div class="answer"><span>绝对不会有机器人的，都是真实用户。</span></div>
      </li>

      <li class="item">
        <div class="question ub ub-pc"><div class="tag"></div><span>绝对不会有机器人的，都是真实用户。</span></div>
        <span></span>
        <div class="answer">
          <span>对方不回复消息的可能性比较多：</span>
          <div><span>1.有可能是对方已经下线了。</span></div>
          <div><span>2.有可能对方正在和很多人聊天，没有时间回复你。</span></div>
          <div><span>3.有可能对方嫌弃你豪气值/魅力值太低了，担心你是骗子。</span></div>
        </div>
      </li>

      <li class="item">
          <div class="question ub ub-pc"><div class="tag"></div><span>积分能干什么？</span></div>
          <div class="answer"><span>积分可以直接提现，目前的兑换比例为 1000:1，即为1000积分可以兑换1元。</span></div>
      </li>

      <li class="item">
          <div class="question ub ub-pc"><div class="tag"></div><span>如何获取积分？</span></div>
          <div class="answer">
            <span>积分的获取方式有很多种:</span>
            <div><span>1.加好友，聊天过程中，对方申请添加你为好友，同意即可获得积分。</span></div>
            <div><span>2.收到礼物，对方给你赠送礼物时会根据一定比例兑换成积分。</span></div>
            <div><span>3.微信号被查看，你的微信号被用户查看即可获得积分。</span></div>
            <div><span>4.每日签到，每日签到可获得随机积分奖励。</span></div>
            <div><span>5.其他方式，平台后期开放。</span></div>
          </div>
      </li>

      <li class="item">
            <div class="question ub ub-pc"><div class="tag"></div><span>在哪里提现？</span></div>
            <div class="answer"><span>提现位置：我的 --> 我的钱包 --> 提现。</span></div>
      </li>

      <li class="item">
            <div class="question ub ub-pc"><div class="tag"></div><span>如何获取金币？</span></div>
            <div class="answer">
              <span>金币的获取方式有多种：</span>
              <div><span>1.直接购买，查看我的金币，有购买金币的详细规则。</span></div>
              <div><span>2.每日签到，随机赠送金币。</span></div>
            </div>
      </li>

      <li class="item">
            <div class="question ub ub-pc"><div class="tag"></div><span>礼物投诉规则</span></div>
            <div class="answer">
              <div><span>如果你对送出去的礼物有异议，或者是对方欺骗了你，你可以针对送出的礼物进行投诉，
              平台会对礼物投诉做出审核，如果确实对方欺骗了你，平台将退还礼物对应的金币，同时收到礼物的人将会收到处罚，
              所得积分将全部退还并且扣罚50%~100%不等，礼物投诉位置：我的 --> 投诉举报 --> 礼物投诉。</span></div>
            </div>
      </li>

      </ul>
  </div>
</template>

<script>
import * as tool from "../../api/common";
  export default {
    data() {
      return {
        data_name: "xxxx",
        theme_dark: false
      };
    },
    mounted() {
      //切换深色模式
      this.theme_dark = tool.is_theme_dark(this);
    },
    methods: {
      back() {
        this.$router.go(-1); //返回上一层
      }
    }
  };
</script>

<style lang="scss" scoped>
.container {
  min-height: 100vh;
  background-color: #EFEFEF;
}
.content {
  padding: 0 0.8rem;
  .item {
    .tag {
      display: inline-block;
      width: 0.5rem;
      height: 1rem;
      background-color: #BA61FF;
      border-radius: 0.5rem;
    }
    .question {
      margin-top: 1.2rem;
      font-size: 0.9rem;
      font-weight: bold;
      span {
        margin-left: 0.5rem;
      }
    }
    .answer {
      margin-top: 1rem;
      font-size: 0.75rem;
      color: #333;
      line-height: 1.3rem;

    }
  }
}

.container-dark {
  background-color: #2f2e33;
  .content {
    .item {
      .question {
        color: #FFFFFF;
      }
      .answer {
        color: #888;
      }
    }
  }
}
</style>
